import colorLib from "@kurkle/color";

export const chartColors=["rgb(57, 0, 107)", "rgb(128, 23, 225)", "rgb(229, 0, 126)", "rgb(250, 181, 18)", "rgb(253, 126, 8)", "rgb(200, 204, 238)", "rgb(208, 88, 208)", "rgb(86, 83, 88)", "rgb(204, 162, 243)", "rgb(254, 203, 156)", "rgb(60, 133, 255)", "rgb(191, 136, 136)", "rgb(226, 85, 85)", "rgb(238, 232, 170)", "rgb(32, 178, 170)", "rgb(175, 238, 238)", "rgb(173,216,230)", "rgb(106, 90, 205)", "rgb(221, 160, 221)", "rgb(255, 105, 180)"];

export function transparentize(value, opacity) {
    var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    return colorLib(value).alpha(alpha).rgbString();
  }